export class User

  @isAdmin: -> document.body.dataset.admin != undefined
  @id: -> parseInt(document.body.dataset.uid)